import { Pipe, PipeTransform } from "@angular/core";
import { convertNumberToAcronyms } from "../common/numberUtils";

@Pipe({
    name: "beautifyDisplayNumber",
    standalone: true,
})
export class BeautifyDisplayNumberPipe implements PipeTransform {
    public transform(value: number): string {
        return convertNumberToAcronyms(value);
    }
}
